"use strict";var eventUtils = require('../../common/event-utils');

module.exports = {
  handleClick(originalEvent) {
    if (!this.input.disabled) {
      this.emit('click', { originalEvent });
    }
  },

  handleKeydown(originalEvent) {var _this = this;
    eventUtils.handleEscapeKeydown(originalEvent, function () {
      if (!_this.input.disabled) {
        _this.emit('escape', { originalEvent });
      }
    });
  } };